module.exports = __webpack_public_path__ + "static/media/collections-star-icon.f9abf2d2.svg";